import { Injectable } from '@angular/core';
import { Inspection } from './inspection.dto';
import { Observable } from 'rxjs';
import { ChangeTyped, SearchResult, WW_INSPECTIONS_COLLECTION } from '@damofire/data-commons';
import { ObservableInspectionService } from './inspection-observable.service';
import { FirebaseObservableServiceFactory } from '@damofire/data-angular-commons';
import { FirebaseWatsonObservableService } from '../firebase-watson-observable.service';
import { TypedDesQuery } from '../des.dto';
import { FirebaseObservableNoteService } from '../note/firebase-note-observable.service';

@Injectable()
export class FirebaseObservableInspectionService extends ObservableInspectionService {
  private readonly firebaseWatsonObservableService: FirebaseWatsonObservableService<Inspection>;

  constructor(
    private readonly firebaseObservableServiceFactory: FirebaseObservableServiceFactory,
    protected readonly firebaseObservableNoteService: FirebaseObservableNoteService,
  ) {
    super(firebaseObservableNoteService);
    this.firebaseWatsonObservableService = new FirebaseWatsonObservableService(firebaseObservableServiceFactory, WW_INSPECTIONS_COLLECTION);
  }

  protected observeById(division: string, id: string): Observable<ChangeTyped<Inspection>> {
    return this.firebaseWatsonObservableService.observeDoc(id);
  }

  noteableSearch(id: string, sQuery: TypedDesQuery): Observable<SearchResult<Inspection>> {
    return this.firebaseWatsonObservableService.search(id, sQuery, this.SEARCH_FIELDS);
  }
}
